



































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class VueJsDialog extends Vue {
    private params = {};
    private defaultButtons = [{ title: 'CLOSE' }];
    private $modal:any;

    @Prop({ type: [Number, String], default: 400 })
    private width: number | string;

    @Prop({ type: [Boolean], default: true })
    private clickToClose: boolean;

    @Prop({ type: [String], default: 'fade' })
    private transition: string;

    get buttons() {
        return (this.params as any).buttons || this.defaultButtons;
    }
    /**
     * Returns FLEX style with correct width for arbitrary number of
     * buttons.
     */
    get buttonStyle() {
        return {
            flex: `1 1 ${100 / this.buttons.length}%`,
        };
    }

    private beforeOpened(event) {
        window.addEventListener('keyup', this.onKeyUp);

        this.params = event.params || {};
        this.$emit('before-opened', event);
    }
    private beforeClosed(event) {
        window.removeEventListener('keyup', this.onKeyUp);

        this.params = {};
        this.$emit('before-closed', event);
    }
    private click(i, event, source = 'click') {
        const button = this.buttons[i];

        if (button && typeof button.handler === 'function') {
            button.handler(i, event, { source });
        } else {
            this.$modal.hide('dialog');
        }
    }
    private onKeyUp(event) {
        if (event.which === 13 && this.buttons.length > 0) {
            const buttonIndex = this.buttons.length === 1 ? 0 : this.buttons.findIndex(button => button.default);

            if (buttonIndex !== -1) {
                this.click(buttonIndex, event, 'keypress');
            }
        }
    }
}
